// extracted by mini-css-extract-plugin
export var active = "_l1-2";
export var recordingDot = "_l1-1";
export var recordingIndicator = "_l1-0";